import React from "react";
import loadjs from "loadjs";
import Loadable from "../../react-loadable";

function getHash(prefix) {
  return `${prefix || "wea_vp_"}${Math.random()
    .toString(36)
    .substr(2, 6)}`;
}
const isDOM =
  typeof HTMLElement === "object"
    ? function(obj) {
        return obj instanceof HTMLElement;
      }
    : function(obj) {
        return (
          obj &&
          typeof obj === "object" &&
          obj.nodeType === 1 &&
          typeof obj.nodeName === "string"
        );
      };

export function getVideoString(options) {
  const {
    videoList,
    videoW,
    videoH,
    videoAlign,
    videoUrl,
    videoTabKey,
    isTCPlayer
  } = options;
  let str = "";
  const align =
    videoAlign === "2" ? "right" : videoAlign === "3" ? "center" : "left";
  // const w = isNaN(parseInt(videoW)) ? "420" : parseInt(videoW);
  // const h = isNaN(parseInt(videoH)) ? "240" : parseInt(videoH);
  // const style = `width: ${w}px; height: ${h}px;`;
  // const WHStyle = `width=${w} height=${h}`;
  let WHStyle = "";
  if (videoW !== "") {
    WHStyle += `width=${videoW};`;
  }
  if (videoH !== "") {
    WHStyle += `height=${videoH};`;
  }
  const videoStyle = `max-width:100%`;
  let wrapStyle = `text-align:${align}`;
  const wrap = (html, other = "") =>
    `<p style=${wrapStyle} ${other}>${html}&#8203;</p><br/>`;
  // const inner = (html, style = "", other = "") =>
  //   `<p class="__wea_vp_class__" style="display:inline-block;${style}" ${other}>${html}</p>`;
  if (videoTabKey === "1") {
    videoList.length > 0 &&
      videoList.map(item => {
        let html = "";
        if (isTCPlayer) {
          html = `<video id=${getHash()} isTCPlayer="1" fileID=${
            item.fileID
          } appID=${
            item.appID
          } style=${videoStyle} ${WHStyle} preload="auto" playsinline webkit-playsinline ${
            item.fileExtendName === "swf" ? "isSwf" : ""
          } ></video>`;
          // html = inner(html);
          html = wrap(html);
        } else {
          if (item.fileExtendName == "swf") {
            html = `<p style="text-align:${align};overflow:hidden;"><embed src=${item.imgSrc ||
              item.loadlink} quality="high" style=${videoStyle} ${WHStyle} align=${align} type="application/x-shockwave-flash" ></embed>&#8203;</p><br/>`;
          } else if (item.fileExtendName == "mp4") {
            html = `<video src=${item.imgSrc ||
              item.loadlink} style=${videoStyle} ${WHStyle} controls="controls" playsinline webkit-playsinline ></video>`;
            // html = `<p style="display:inline-block;${style}">${html}</p>`;
            html = wrap(html);
          } else {
            html = `<video src=${item.imgSrc ||
              item.loadlink} style=${videoStyle} ${WHStyle} controls="controls" playsinline webkit-playsinline ></video>`;
            // html = inner(html, style, `id=${getHash()} ${WHStyle}`);
            html = wrap(html);
          }
        }
        str += html;
      });
  } else {
    let html = `<video src=${videoUrl} style=${videoStyle} ${WHStyle} controls="controls" playsinline webkit-playsinline ></video>`;
    // html = inner(html, style, `id=${getHash()} ${WHStyle}`);
    html = wrap(html);
    str += html;
  }
  return str;
}

export function loadVideoPlayer(options = {}, style = {}, isTCPlayer) {
  const opt = isTCPlayer
    ? options
    : {
        ...options,
        video: options.video || "",
        container: options.container || getHash(),
        variable: "player"
      };
  const content = opt.video ? "loading..." : "暂无视频";
  const init = () => {
    setTimeout(() => {
      try {
        const player = isTCPlayer
          ? new TCPlayer(opt.container || getHash(), opt)
          : new videoPlayer(opt);
      } catch (e) {
        console.log(e);
      }
    }, 200);
  };
  const getDom = opt =>
    isTCPlayer ? (
      <video
        isTCPlayer="1"
        id={opt.container}
        style={style}
        preload="auto"
        playsinline
        webkit-playsinline
      />
    ) : (
      <div id={opt.container.substr(1)} style={style}>
        {content}
      </div>
    );
  const playerName = isTCPlayer ? "TCPlayerJS" : "videoPlayerJS";
  loadjs.isDefined(playerName)
    ? loadjs.ready(playerName, init)
    : loadjs(
        isTCPlayer
          ? [
              "/cloudstore/resource/pc/tcplayer/tcplayer.css",
              "/cloudstore/resource/pc/tcplayer/libs/hls.min.0.12.4.js",
              "/cloudstore/resource/pc/tcplayer/libs/dash.all.min.2.9.3.js",
              "/cloudstore/resource/pc/tcplayer/tcplayer.min.js"
            ]
          : "/cloudstore/resource/pc/videoPlayer/index.min.js",
        playerName,
        init
      );

  return getDom(opt);
}

export function renderVideoPlayer(dom, appID) {
  dom = dom || window.document.body;
  if (!isDOM(dom)) return;
  dom = dom.querySelectorAll(".__wea_vp_class__") || [];
  const loop = videoWrap => {
    if (isDOM(videoWrap)) {
      const videoDom = videoWrap.querySelector("video");
      if (!videoDom) return;
      if (videoDom.getAttribute("isTCPlayer")) {
        const container = videoDom.id;
        const fileID = videoDom.getAttribute("fileID");
        appID = appID || videoDom.getAttribute("appID");
        const swf = videoDom.getAttribute("isswf");
        const width = videoDom.getAttribute("width");
        const height = videoDom.getAttribute("height");
        let options = { container, fileID, appID, width, height };
        if (swf) {
          options = {
            ...options,
            flash: {
              swf: "/cloudstore/resource/pc/tcplayer/player.swf" //swf 文件地址 必须
            }
          };
        }
        loadVideoPlayer(options, { width, height }, true);
      } else {
        const container = `#${videoWrap.id}`;
        const video = videoDom.src;
        const width = videoDom.getAttribute("width");
        const height = videoDom.getAttribute("height");
        loadVideoPlayer({ container, video }, { width, height });
      }
    }
  };
  if (dom && dom.length > 0) {
    for (let index = 0; index < dom.length; index++) {
      loop(dom[index]);
    }
  } else {
    loop(dom);
  }
}

const Main = Loadable({
  loader: () => import("./Video"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
Main.getVideoString = getVideoString;
Main.loadVideoPlayer = loadVideoPlayer;
Main.renderVideoPlayer = renderVideoPlayer;

export default Main;



// WEBPACK FOOTER //
// ./ecology9/wea-video/index.js